import { render, staticRenderFns } from "./FooterFullPage.vue?vue&type=template&id=fed7d4c6&scoped=true&"
import script from "./FooterFullPage.vue?vue&type=script&lang=js&"
export * from "./FooterFullPage.vue?vue&type=script&lang=js&"
import style0 from "./FooterFullPage.vue?vue&type=style&index=0&id=fed7d4c6&prod&lang=scss&"
import style1 from "./FooterFullPage.vue?vue&type=style&index=1&id=fed7d4c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed7d4c6",
  null
  
)

export default component.exports